export default "__VITE_ASSET__aQNidW3T__"